import { render, staticRenderFns } from "./Recount__plotsSolid.vue?vue&type=template&id=87ee9320&scoped=true&"
import script from "./Recount__plotsSolid.vue?vue&type=script&lang=js&"
export * from "./Recount__plotsSolid.vue?vue&type=script&lang=js&"
import style0 from "./Recount__plotsSolid.vue?vue&type=style&index=0&id=87ee9320&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87ee9320",
  null
  
)

export default component.exports